import { TYPES } from '../const'

export default class Mask {
	private readonly shape: any
	private readonly elements: any
	private readonly type: string

	constructor(shape, elements) {
		this.shape = shape
		this.elements = elements
		this.type = TYPES.MASK
	}

	init(gl, programs) {
		const { shapeProgram, imgProgram, blurImgProgram, slidesProgram } = programs
		this.shape.init(gl, shapeProgram)
		this.elements.forEach((el) => {
			switch (el.type) {
				case TYPES.SHAPE:
					el.init(gl, shapeProgram)
					break
				case TYPES.IMG:
					el.init(gl, imgProgram)
					break
				case TYPES.VIDEO:
					el.init(gl, imgProgram)
					break
				case TYPES.BLUR_IMG:
					el.init(gl, imgProgram, blurImgProgram)
					break
				case TYPES.SLIDES:
					el.init(gl, slidesProgram)
					break
			}
		})
	}

	resize(width, height) {
		this.shape.resize(width, height)
		this.elements.forEach((element) => element.resize(width, height))
	}

	setAnchor(left, top) {
		this.elements.forEach((el) => el.setAnchor(left, top))
	}

	draw(gl) {
		gl.clear(gl.STENCIL_BUFFER_BIT)

		gl.stencilFunc(gl.ALWAYS, 1, 1)
		gl.stencilOp(gl.REPLACE, gl.REPLACE, gl.REPLACE)

		gl.colorMask(false, false, false, false)
		gl.enable(gl.STENCIL_TEST)

		this.shape.draw(gl)

		gl.stencilFunc(gl.EQUAL, 1, 1)
		gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP)

		gl.colorMask(true, true, true, true)

		this.elements.forEach((element) => element.draw(gl))

		gl.disable(gl.STENCIL_TEST)
	}

	async animateIn(forward) {
		await Promise.all([
			this.shape.animateIn(forward),
			...this.elements.map((element) => element.animateIn(forward))
		])
	}

	async animateOut(forward) {
		await Promise.all([
			this.shape.animateOut(forward, false),
			...this.elements.map((element) => element.animateOut(forward))
		])

		this.shape.visible = false
	}

	async preload(gl) {
		await Promise.all(this.elements.map((el) => el.preload(gl)))
	}
}
